import { Component, OnInit, ChangeDetectorRef, Input, ViewChild, ElementRef, AfterViewInit, Renderer2, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { InputDialog } from '../../input-dialog/dialog-input';
import { SettingsService } from 'src/app/settings/settings.service';;
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { InfoModalOnboarding } from 'src/app/onboarding/info-modal/info-modal';
import { CambiarEmpresa } from 'src/app/layout/cambiar-empresa/cambiar-empresa';
declare var $ :any;

@Component({
    selector: 'app-clavesii',
    templateUrl: './clavesii.html',
    styleUrls: ['./clavesii.less'],
    standalone: false
})


export class ClaveSIIComponent implements OnInit, AfterViewInit {
   
  @Input() id_company:any;
  @Input() data:any;
  @Input() token:any;
  @Input() parent:any;
  /** `bloqueo_clave` de obtener-credenciales-sii: intentos restantes y hasta cuándo. */
  @Input() bloqueo:any;
  spinner_btn:boolean=false;

  /** Qué está pasando: «Validando con el SII…» y después «Guardando…». */
  fase: '' | 'validando' | 'guardando' = '';
  /** `clave_sii` de la respuesta: `codigo`, `intentos_restantes`, `desbloqueo_en`. */
  resultado:any = null;

  rut_company = localStorage.getItem('rut');
  business_name = localStorage.getItem('business_name')


  valForm: FormGroup;

  constructor(public snackBar: MatSnackBar, 
    private router: Router, public dialog: MatDialog,  
    public settings: SettingsService,
    private _formBuilder: FormBuilder, 
    private dialogRef:MatDialogRef<ClaveSIIComponent>,
    private ngZone: NgZone,
    private renderer: Renderer2
  ){


      this.valForm = this._formBuilder.group({
        'clave_sii': ['',  Validators.compose([Validators.required])],
      });

  }

  ngOnInit() {

    this.id_company = localStorage.getItem('company_id');

    this.business_name = localStorage.getItem('business_name');
    this.rut_company = localStorage.getItem('rut');

    this.get_credenciales()
    if (this.bloqueo?.bloqueado) {
      this.resultado = { codigo: 'BLOQUEADO', ...this.bloqueo };
    }

  }

  /** «12:06» desde el ISO con offset de Chile que manda el backend (sin convertir zonas). */
  hora(iso:any): string {
    return typeof iso === 'string' && iso.length >= 16 ? iso.substring(11, 16) : '';
  }

  get bloqueado(): boolean {
    return this.resultado?.codigo === 'BLOQUEADO'
      || (this.resultado?.codigo === 'CLAVE_INCORRECTA' && !!this.resultado?.desbloqueo_en);
  }

  get aviso(): { clase: string, icono: string, titulo: string, detalle: string } | null {
    const r = this.resultado;
    if (!r || r.codigo === 'OK') return null;
    const quedan = r.intentos_restantes;
    switch (r.codigo) {
      case 'CLAVE_INCORRECTA':
        return r.desbloqueo_en
          ? { clase: 'error', icono: 'lock', titulo: 'La clave no es correcta',
              detalle: `Por seguridad, podrás volver a intentarlo a las ${this.hora(r.desbloqueo_en)}.` }
          : { clase: 'error', icono: 'error', titulo: 'La clave no es correcta',
              detalle: quedan == null ? 'Revisa que sea la que usas en sii.cl.'
                : `Revisa que sea la que usas en sii.cl. Te ${quedan == 1 ? 'queda 1 intento' : `quedan ${quedan} intentos`}.` };
      case 'BLOQUEADO':
        return { clase: 'warn', icono: 'lock', titulo: `Podrás intentarlo de nuevo a las ${this.hora(r.desbloqueo_en)}`,
                 detalle: 'Hubo varios intentos con una clave incorrecta. Esperar evita que el SII bloquee tu clave.' };
      case 'CLAVE_BLOQUEADA_SII':
        return { clase: 'error', icono: 'block', titulo: 'Tu clave está bloqueada en el SII',
                 detalle: 'Desbloquéala en sii.cl y vuelve a intentarlo.' };
      case 'SII_TOPE_SESIONES':
        return { clase: 'neutro', icono: 'hourglass_empty', titulo: 'El SII tiene el máximo de sesiones abiertas',
                 detalle: 'Intenta de nuevo en unos minutos. No se descontó un intento.' };
      default:
        return { clase: 'neutro', icono: 'cloud_off', titulo: 'El SII no respondió',
                 detalle: 'Intenta de nuevo en unos minutos. No se descontó un intento.' };
    }
  }

  /**
   * El backend dijo qué pasó (`clave_sii.codigo`): se muestra en el diálogo. `false` si la
   * respuesta no lo trae (backend anterior) y hay que caer al manejo de siempre.
   */
  private mostrar_rechazo(bd:any): boolean {
    const clave_sii = bd?.status == 400 ? bd.error?.clave_sii : null;
    if (!clave_sii?.codigo) return false;
    this.resultado = clave_sii;
    if (clave_sii.codigo == 'CLAVE_INCORRECTA') {
      this.valForm.controls['clave_sii'].setErrors({'incorrect': true});
    }
    return true;
  }

    ngAfterViewInit(): void {

    setTimeout(() => {
      this.setupMutationObserver();
      this.detectDevTools();
    });
  }

  get_credenciales(){
    this.clave_sii = this.data?.clave_sii;
    if(this.clave_sii != null && this.clave_sii != "" && this.clave_sii != undefined){
      this.valForm.controls['clave_sii'].setValue(this.clave_sii)
    }
  }

  clave_sii:any;

  disable_btn:boolean=true;
  validate_key($event:any){
    if($event.target.value != undefined && $event.target.value != null && $event.target.value != ""){
      this.disable_btn = false;
    }else{
      this.disable_btn = true;
    }
    // Otra clave: el aviso anterior ya no aplica (salvo el bloqueo).
    if (this.resultado && !this.bloqueado) {
      this.resultado = null;
    }
  }



  //CLAVE SII
  saving_sii:boolean=false;
  success_sii:boolean=false;
  update(){

    this.dialogRef.close(true)

    this.snackBar.open("Cambio de Clave Exitoso", "Aceptar", {
      duration: 10000,
      panelClass: "simpli-snack"
    });

  }

  open_input_dialog(title:any,subtitle:any,mensajeprincipal:any, mensajenegrita:any,icon:any,coloricon:any) {
    const dialogRef = this.dialog.open(InputDialog, {
      width: '700px',
      autoFocus: false,
    });
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.subtitle = subtitle;
    dialogRef.componentInstance.mensajeprincipal = mensajeprincipal;
    dialogRef.componentInstance.mensajenegrita = mensajenegrita;
    dialogRef.componentInstance.icon = icon;
    dialogRef.componentInstance.coloricon = coloricon;

    dialogRef.afterClosed().subscribe((result:any) => {

    });
  }

  // Back nuevo app cliente


  async verificar_guardar_clave_sii(validate?:any){
    try {

      this.spinner_btn = true;
      this.fase = 'validando';

      let value:any = {"sii_key": this.valForm.controls['clave_sii'].value}
      if (validate) {
        value["validate"] = true;
      }
  
      this.disable_btn = true;

      const bd: any = await this.settings.get_query(3, `cliente/validate-clave-sii/${this.id_company}/`,value );
      var body_data: any =bd._body;
      switch (bd.status) {
        case 200:



        this.guardar_clave_sii();





        break;
        default:

        break;
      }

    } catch (bd:any) {


      this.fase = '';
      this.saving_sii = false;
      this.disable_btn = false;
      this.success_sii = false;
      this.spinner_btn = false;
      if (this.mostrar_rechazo(bd)) return;
      this.valForm.controls['clave_sii'].setErrors({'incorrect': true});
      
      switch (bd.status) {
        case 500:

            this.snackBar.open('Ocurrió un error, intenta de nuevo', 'Aceptar', {
              duration: 20000,
              panelClass: 'simpli-snack'
            });
          break;

      case 400:
        let error = "Acceso bloqueado. Intente nuevamente más tarde."
        if(bd.error.error.errors.non_field_errors[0] == error){
          this.open_modal_info_disable(9); 
          this.valForm.disable();
        } else {
          this.open_modal_info(8); 
        }

          break;
        default:

            this.snackBar.open('Ocurrió un error, intenta de nuevo', 'Aceptar', {
              duration: 20000,
              panelClass: 'simpli-snack'
            });

        break;
      }
    }
  }

  async guardar_clave_sii(){
  try {

    this.spinner_btn = true;
    this.fase = 'guardando';
    let value:any = {"sii_key": this.valForm.controls['clave_sii'].value}
    value["validate"] = false;
    this.disable_btn = true;

    const bd: any = await this.settings.get_query(3, `cliente/validate-clave-sii/${this.id_company}/`,value );
    var body_data: any =bd._body;
    switch (bd.status) {
      case 200:


      this.success_sii = true;
      this.saving_sii = false;
      this.fase = '';


      this.update();

      this.disable_btn = false;
      this.spinner_btn = false;



      break;
      default:

      break;
    }

  } catch (bd:any) {


    this.fase = '';
    this.saving_sii = false;
    this.disable_btn = false;
    this.success_sii = false;
    this.spinner_btn = false;
    if (this.mostrar_rechazo(bd)) return;
    this.valForm.controls['clave_sii'].setErrors({'incorrect': true});
    
    switch (bd.status) {
      case 500:

          this.snackBar.open('Ocurrió un error, intenta de nuevo', 'Aceptar', {
            duration: 20000,
            panelClass: 'simpli-snack'
          });
        break;

    case 400:
      let error = "Acceso bloqueado. Intente nuevamente más tarde."
      if(bd.error.error.errors.non_field_errors[0] == error){
        this.open_modal_info_disable(9); 
        this.valForm.disable();
      } else {
        this.open_modal_info(8); 
      }

        break;
      default:

          this.snackBar.open('Ocurrió un error, intenta de nuevo', 'Aceptar', {
            duration: 20000,
            panelClass: 'simpli-snack'
          });

      break;
    }
  }
  }

  open_modal_info(step:any) {
    let dialogRef = this.dialog.open(InfoModalOnboarding, {
      width: '700px',
      autoFocus: false,
    });

    dialogRef.componentInstance.step = step;

  }

    open_modal_info_disable(step:any) {
  
  
      
      let dialogRef = this.dialog.open(InfoModalOnboarding, {
        width: '700px',
        autoFocus: false,
        disableClose: false
      });
  
      dialogRef.componentInstance.step = step;

      dialogRef.afterClosed().subscribe(result => {
  
      });
  
    }

      cambiarEmpresa() {
        const dialogRef = this.dialog.open(CambiarEmpresa, {
          width: '700px',
          autoFocus: false,
        });
    
        dialogRef.componentInstance.element = this;
        dialogRef.componentInstance.se_abrio_desde_clave = true;
        dialogRef.afterClosed().subscribe((result:any) => {
          this.valForm.enable();
          this.disable_btn = true;
          this.success_sii = false;
          this.saving_sii = false;
        });
      }

      reset_parent(){
        console.log("reset parent")
        this.parent.ngOnInit();
        this.credencialessii();
      }


      async credencialessii(){
        try {
    
    
    
          const bd: any = await this.settings.get_query(1, `cliente/obtener-credenciales-sii/${this.id_company}/`, );
          var body_data: any = bd._body;
          switch (bd.status) {
            case 200:
    
    
    
            this.data = body_data.success.info;
    
            this.valForm.controls['clave_sii'].setValue(this.data.clave_sii);

            console.log("ACA PAPA",this.data)
    

    
            break;
            default:
    
            break;
          }
    
        } catch (bd:any) {
    

        }
      }

  @ViewChild('passwordInput1') passwordInput1!: ElementRef;
  setupMutationObserver(): void {
    const passwordInput1 = this.passwordInput1.nativeElement;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'type') {
          if (passwordInput1.type !== 'password') {
            this.renderer.setAttribute(passwordInput1, 'type', 'password');
              this.open_input_dialog( "Advertencia",
                "Error de privacidad",
                "Por favor, cierra la consola de desarrollo",
                "No deberías tener las herramientas de desarrollo abiertas, no vulnere la privacidad del cliente, lo tenemos indetificado.",
                "warning",
                "#f39c12");
          }
        }
      });
    });

    observer.observe(passwordInput1, { attributes: true });
  }

  detectDevTools(): void {
    this.ngZone.runOutsideAngular(() => {
      let devtoolsOpen = false;
      const threshold = 160; // Milisegundos

      const detect = () => {
        const start = performance.now();
        //debugger;
        const end = performance.now();
        if (end - start > threshold) {
          if (!devtoolsOpen) {
            devtoolsOpen = true;
            this.ngZone.run(() => {
              this.open_input_dialog( "Advertencia",
                "Error de privacidad",
                "Por favor, cierra la consola de desarrollo",
                "No deberías tener las herramientas de desarrollo abiertas, no vulnere la privacidad del cliente, lo tenemos indetificado.",
                "warning",
                "#f39c12");
            });
          }
        } else {
          devtoolsOpen = false;
        }
      };

      setInterval(detect, 1000);
    });
  }
  
}

